import { IBeneficiosVt } from '@core/models';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppState } from '@store/store';

interface IBeneficiosVtState {
    data: IBeneficiosVt[];
    loading: boolean;
    error: string | null;
}

const initialState: IBeneficiosVtState = {
    data: [] as IBeneficiosVt[],
    loading: false,
    error: null
};

export const beneficiosVtSlice = createSlice({
    name: 'beneficiosVt',
    initialState,
    reducers: {
        beneficiosVt_fetching: (state) => {
            state.loading = true;
            state.data = [] as IBeneficiosVt[];
            state.error = null;
        },
        beneficiosVt_success: (state, action: PayloadAction<IBeneficiosVt[]>) => {
            state.error = null;
            state.loading = false;
            state.data = action.payload;
        },
        beneficiosVt_error: (state, action: PayloadAction<string>) => {
            state.error = action.payload;
            state.loading = false;
            state.data = [] as IBeneficiosVt[];
        }
    }
});

export const { beneficiosVt_fetching, beneficiosVt_success, beneficiosVt_error } = beneficiosVtSlice.actions;

export const selectorBeneficiosVt = (state: AppState) => state.beneficiosVt;

export default beneficiosVtSlice.reducer;
